import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCopyValues = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "meal_plan",
	"data-name": "meal plan",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("polygon", {
			className: "plan2plate-icon",
			points: "3.41,22.5 3.41,5.32 16.77,5.32 16.77,8.18 16.77,22.5 ",
			id: "polygon3"
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "plan2plate-icon",
			points: "16.77 18.68 20.59 18.68 20.59 4.36 20.59 1.5 7.23 1.5 7.23 5.32",
			id: "polyline3"
		})
	]
});
const ForwardRef = forwardRef(SvgCopyValues);
export default ForwardRef;
